export * from './voltio-landing/voltio-landing';
export * from './resident/resident-register/resident-register';
export * from './resident/resident-summary/resident-summary';
export * from './bill/bill-summary/bill-summary';
export * from './bill/bill-create/bill-create';
export * from './themes/themes';
export * from './login/login';
export * from './signup/signup';
export * from './logout/logout';
export * from './project-number-generator/project-number-generator';



// WEBPACK FOOTER //
// ./src/pages/index.ts